import React, {Component} from 'react';
import { Form, Checkbox } from 'semantic-ui-react'
import PropTypes from 'prop-types';
class CommessaStatoSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                isChiusa: props.isChiusa,
                isArchiviata: props.isArchiviata,
            }
        };
        this.onTipoChange = this.onTipoChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            fields: {
                isChiusa: nextProps.isChiusa,
                isArchiviata: nextProps.isArchiviata,
            }
        })
    }

    onTipoChange(a1, {name, checked}){
        let fields = this.state.fields;
        fields[name] = checked;
        this.setState({fields})
        this.props.onChange(fields.isChiusa, fields.isArchiviata);
    }

    render() {
        return (
        <div className="ui stackable form">
            <Form.Group widths="2">
                <Form.Field inline >
                    <Checkbox label="Prestazioni concluse" name="isChiusa" toggle checked={this.state.fields.isChiusa} onChange={this.onTipoChange} />
                </Form.Field>
                <Form.Field inline >
                    <Checkbox label="Commesse archiviate" name="isArchiviata" toggle checked={this.state.fields.isArchiviata} onChange={this.onTipoChange} />
                </Form.Field>
            </Form.Group>
        </div>)
    }
}

CommessaStatoSelect.PropTypes = {
    isChiusa: PropTypes.bool.isRequired,
    isArchiviata: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

CommessaStatoSelect.defaultProps = {
    isChiusa: false,
    isArchiviata: false,
};
export default CommessaStatoSelect;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommessaStatoSelect.js
 **/